<template lang="html">
  <section>
    <a  class="btn btn-info btn-sm"  @click="getEmailPreviewRaiseTicket()" title="Email Preview" target="iframe_a">
      <span v-if="buttonType ==='button'">Email Preview Raise Ticket</span>
      <span v-if="buttonType ==='eye'">
       <i class="fa fa-eye"></i>
      </span>
    </a>
     <!-- <b-modal size="vlg" v-model="isActiveLogModal" @close="closePreviewModal()" :no-close-on-backdrop="true"> -->
    <div id="previewRaiseTicket1" style="display: none;">  
         <!-- <div class="card-header" >
            <h5>Email Message</h5>
            <button type="button" aria-label="Close" @click="closePreviewModal()" class="close"
            style="display: inline;position: relative;bottom: 30px;" title="Close">×</button>
          </div> -->

        <div class="card-body">
            <b-table sticky-header class="table-outline mb-0" hover striped responsive="sm" outline
              :fields="emailPreviewFields"
              :items="emailMessageArray"
              head-variant="default"
              v-model="currentItems"
            >
            <template slot="show_details" scope="{ detailsShowing, item }" >
              <!-- Use the built in method from the scoped data to toggle the row details -->
              <b-btn @click="toggleDetails(item)">{{ detailsShowing ? 'Hide' : 'Show'}}</b-btn>
            </template>
            <template slot="row-details" scope="{ item }">
              <div clab-modalss="card-body">
                <div class="row mb-4">
                  <div class="col-sm-4">
                    <div>
                      <b>Email From :</b>
                      {{item.fromid}}
                    </div>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-sm-4">
                    <div>
                      <b>Email To :</b>
                      {{item.toid}}
                    </div>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-sm-4">
                    <div>
                      <b>Email CC :</b>
                      {{item.cc}}
                    </div>
                  </div>
                </div>
                 <div class="row mb-4">
                  <div class="col-sm-4">
                    <b>Email Subject :</b>
                    <span v-html="item.subject"></span>
                  </div>
                </div>
                <div class="row mb-8">
                  <div class="col-sm-8">
                      <b>Email Body :</b>
                      <span class="test" v-html="item.emailbody"></span>
                  </div>
                </div>
              </div>
            </template>
             <!-- A custom formatted column -->
            <template slot="emaildate" scope="item" >
              <span>{{ item.value | dateFilter }}</span>
            </template>
             <!-- A custom formatted column -->
            <template slot="emailtype" scope="item" >
              <span v-if="item.value.toLowerCase() == 'in'">Received</span>
              <span v-if="item.value.toLowerCase() == 'out'">Sent</span>
            </template>

            <!-- A custom formatted column -->
            <template slot="isattachment" scope="item" >
              <span>
                <span v-if="item.item.emailtype === 'in' && item.value && item.value && item.value.toLowerCase() ==='yes'">
                  <router-link :to="{ path: encodeURI('/emailattachment'), query: {inboxID : item.item.inboxid, caseID:item.item.caseid} }"  id="link" title="View Attachment" target="_blank"><a>View Attachment</a></router-link>
                </span>
                <span v-if="item.item.emailtype === 'out' && item.value && item.value && item.value.toLowerCase() ==='yes'">
                  <router-link :to="{ path: encodeURI('/emailattachment'), query: {outboxID : item.item.id, caseID:item.item.caseid} }"  id="link" title="View Attachment" target="_blank"><a>View Attachment</a></router-link>
                </span>
                <span v-if="item.value && item.value && item.value.toLowerCase() ==='no' || item.value === ''">
                    No
                </span>
              </span>
            </template>
        </b-table>
        </div>
    </div>
    <!--Preview Modal End  -->
  </section>
</template>

<script>
import apiUrl from '../../../constants'
import axios from 'axios'
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import commonFunction from '../../../commonFunction'
import constantVariable from '../../../constantVariable'

export default {
  name: 'EmailPreviewRaiseTicket',
   components: {
      Loading
    },
  data () {
    return {
      emailMessageArray: [],
      isActiveLogModal: false,
      ticketid: '',
      emailcaseID: '',
      defaultSortDirection: 'desc',
      isLoading: true,
      defaultOpenedDetails: [],
      currentItems: [],
      emailPreviewFields: {
        caseid: {
          key: 'caseid',
          label: 'Case ID',
          class: 'row-ID'
        },
        fromid: {
          key: 'fromid',
          label: 'Email From',
          class: 'row-Desc'
        },
        emaildate: {
          key: 'emaildate',
          label: 'Email Date',
          class: 'row-incident-level'
        },
        emailtype: {
          key: 'emailtype',
          label: 'Email Type',
          class: ' row-Date'
        },
        subject: {
          key: 'subject',
          label: 'Subject',
          class: 'row-ID'
        },
        isattachment: {
          key: 'isattachment',
          label: 'Attachment'
        },
        lastmodifiedby: {
          key: 'lastmodifiedby',
          label: 'Last Modified By'
        },
        show_details:{
          key: 'show_details',
          label: '',
          _style: { width: '1%' },
          sorter: false,
          filter: false
        }
      },
      emailPreviewModal : false,
      isModalLoading : false,
      fullPage: false
    }
  },
  filters: {
    //formatDate: filters.formatDate

  },
  props: ['setTicketID', 'setCaseID', 'buttonType'],
  created () {
    // do something after creating vue instance
    this.ticketid = this.setTicketID
    this.emailcaseID = this.setCaseID
       this.isActiveLogModal = false;
    // console.log( 'created' );
  },
  watch: {
    setTicketID: function (o, n) {
      this.ticketid = this.setTicketID
    },
    setCaseID: function (o, n) {
      this.emailcaseID = this.setCaseID
    }
  },
  methods: {
    toggleDetails(item) {
      // console.log( 'item : '+JSON.stringify( item ) );
      if(item._showDetails){
        this.$set(item, '_showDetails', false)
      }else{
        this.currentItems.forEach(item => {
          this.$set(item, '_showDetails', false)
        })

        this.$nextTick(() => {
          this.$set(item, '_showDetails', true)
        })
      }
    },
    /**
     * [On click of ticketid from ticket details tab email preview api called.]
     * @return {[type]} [getEmailPreview]
     */
    getEmailPreviewRaiseTicket: function () {

      this.fromemail = ''
      this.toemail = ''
      this.emailsubject = ''
      this.emailmessage = ''
      this.recipientid = ''
      this.carboncopy = ''
      this.previetickid = ''
      let emailPreviewTicketDetails = {
        ticketid: this.ticketid,
        caseid: this.emailcaseID
      }
      this.isLoading = true
      this.emailMessageArray = []

      return axios({
        'method': 'POST',
        'url': apiUrl.api_url + 'getemaildetails',
        headers: commonFunction.getusertoken(),
        'data': emailPreviewTicketDetails
      }).then((result) => {
          console.log( 'result  getEmailPreview : '+JSON.stringify( result ) );
         // console.log( 'outbox : '+result.outbox );
          //console.log( 'outbox stringify : '+JSON.stringify( result.outbox ) );
          this.isLoading = false
          let emails = []
          if (result.data) {
            if (result.data) {
              if (result.data) {
                if( result.data.outbox != undefined && result.data.outbox.length > 0 ) {
                  // console.log( 'outbox record' );
                  result.data.outbox.forEach((outbox) => {
                      if (outbox) {
                        let base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/
                        let isEncoded = (outbox.emailbody && outbox.emailbody) ? base64regex.test(outbox.emailbody.toString()) : ''
                        if (isEncoded) { // If string is encoded in base64 format then decode string
                          outbox.emailbody = Buffer.from(outbox.emailbody, 'base64').toString()
                        }
                        emails.push({
                          emailbody: (outbox.emailbody && outbox.emailbody) ? outbox.emailbody : '',
                          caseid: outbox.caseid,
                          emailtype: (outbox.emailtype) ? outbox.emailtype : '',
                          emaildate: (outbox.createddate) ? outbox.createddate : '',
                          subject: (outbox.subject) ? outbox.subject : '',
                          isattachment: (outbox && outbox.isattachment) ? outbox.isattachment : '',
                          inboxid: (outbox.inboxid) ? outbox.inboxid : '',
                          id: (outbox.id) ? outbox.id : '',
                          lastmodifiedby: outbox.createdby,
                          fromid: apiUrl.EMAILR_CONFIG_DATA[0].EMAILR_ACK_EMAIL.trim().toLowerCase(),
                          cc: outbox.cc ? outbox.cc : '',
                          toid: outbox.toid ? outbox.toid : ''
                        })
                      }
                  })
                }
              }
              result.data.inbox.forEach((inbox) => {
                  let base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/
                  let isEncoded = (inbox.emailbody && inbox.emailbody) ? base64regex.test(inbox.emailbody.toString()) : ''
                  if (isEncoded) { // If string is encoded in base64 format then decode string
                    inbox.emailbody = Buffer.from(inbox.emailbody, 'base64').toString()
                  }

                  emails.push({
                    emailbody: (inbox && inbox.emailbody && inbox.emailbody) ? inbox.emailbody : '',
                    caseid: inbox.caseid,
                    emailtype:  (inbox.emailtype) ? inbox.emailtype : '',
                    emaildate: (inbox && inbox.createddate) ? inbox.createddate : '',
                    subject: (inbox && inbox.subject) ? inbox.subject : '',
                    isattachment: (inbox && inbox.isattachment) ? inbox.isattachment : '',
                    inboxid: (inbox && inbox.inboxid) ? inbox.inboxid : '',
                    lastmodifiedby: inbox.lastmodifiedby || '',
                    fromid: (inbox && inbox.fromid) ? inbox.fromid : '',
                    toid: inbox.toid ? inbox.toid : '',
                    cc: inbox.cc ? inbox.cc : ''
                  })
                  //console.log( 'inbox : '+JSON.stringify( inbox ) );
                  //console.log( 'emails : '+ JSON.stringify( emails ) );
              })
            }
            // console.log( 'Emails : '+emails.length );

            if (emails.length) {
              emails.forEach((b) => {
                if (!this.isHTML(b.emailbody)) {
                  b.emailbody = '<pre>' + b.emailbody + '</pre>'
                }
              })
              this.defaultOpenedDetails.push(emails[emails.length - 1])
              emails.sort(function(fDate, sDate) {
                  if (sDate.emaildate && fDate.emaildate) {
                    return new Date(sDate.emaildate)-new Date(fDate.emaildate); // Will sort emaildate desc
                  }
              });
              this.emailMessageArray = emails
            }

          }
          // console.log( 'emailMessageArray Data : '+JSON.stringify( this.emailMessageArray ) );

        }).then(() => {

        
  var test1 = document.getElementById("previewRaiseTicket1");
  if (test1.style.display === "none") {
    test1.style.display = "block";
  } else {
    test1.style.display = "none";
  }


  
        })
        .catch((httpException) => {
          this.isLoading = false
          return this.$alertify.error(httpException.message);
        })
    },


    isHTML (str) {
      var doc = new DOMParser().parseFromString(str, 'text/html')
      return Array.from(doc.body.childNodes).some(node => node.nodeType === 1)
    },
    getDetailsLevel: function (data) {
      this.emailPreviewModal = true;
      this.defaultOpenedDetails = [data]
    },
    closePreviewModal: function () {
      this.defaultOpenedDetails = []
      this.isActiveLogModal = false
    },
    expandAdditionalInfo(item) {
      item._showDetails = !item._showDetails;
    },
  }
}
</script>

<style lang="css" scoped="">
.customModal {
  width: 90vw !important;
  height: 75% !important;
}
#link {
    color: #3273dc !important;
}
.modal-card-body{
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}
.test {
white-space:pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/views/components/emailr/EmailPreviewRaiseTicket.vue?674297f3